var lng = $('html').attr('lang');

var delayInputBox = 7;
var rewindEnd = 40;
var rewindStart = 20;

word1 = document.getElementById('word-1');
word2 = document.getElementById('word-2');

var Video = function(data) {
    var self = this;

    this.getVideoTag = function(url_video, url_poster) {
        return '<video playsinline disableRemotePlayback poster="'+url_poster+'">\n' +
            '          <source src="'+url_video+'" type="video/mp4">\n' +
            '   </video>';
    }

    this.start = function() {
        var wrapper = $('.video-wrapper');
        var inner = wrapper.find('.video-inner');

        inner.append(this.getVideoTag('video_'+lng+'/intro_1080.mp4', 'img/poster.jpg'));

        var video = inner.find('video');
        var form = wrapper.find('.input-box');
        var continueBtn = wrapper.find('.btn-continue');

        wrapper.removeClass('initial');

        video.on('canplay', function(){

            setTimeout(function(){
                var playPromise = video[0].play();

                // In browsers that don’t yet support this functionality,
                // playPromise won’t be defined.
                if (playPromise !== undefined) {
                    playPromise.then(function() {
                        // Automatic playback started!
                        video.parent().parent().removeClass('paused');
                    }).catch(function(error) {
                        //trackJs.track(error);
                        console.log('promise error');
                        console.log(error);
                        clearTimeout(self.videoTimeout);
                        // Automatic playback failed.
                        // Show a UI element to let the user manually start playback.

                        video.off('timeupdate');
                        video.addClass('finished');
                    });
                } else {
                    //video.parent().parent().removeClass('paused');
                }

            },250);

        });

        self.videoTimeout = setTimeout(function(){
            if (video[0].currentTime > 0) {
                console.log('video timeout too late');
            } else {
                window.location.reload();
            }
        },10000);

        video[0].load();

        video.on('timeupdate', function(e){
            if (video[0].currentTime > 0) {
                clearTimeout(self.videoTimeout);
                //self.container.find('.spinner').remove();
            }
            if (video[0].currentTime > delayInputBox) {
                video.off('timeupdate');
                wrapper.addClass('show-input-box');
            }
            if (video[0].currentTime > rewindEnd) {
                video[0].currentTime = rewindStart;
            }
        });

        wrapper.on('click', '.input-skip a', function(){
            var form = $(this);

            self.outro();

            return false;
        });

        form.on('submit', function(){
            var form = $(this);

            self.outro();

            $.post(form.attr('action'), form.serialize(), function(response){
                preloadImage(response.word1);

                $('#word-1').html('<img src="'+response.word1+'">');
                $('#word-2').html('<img src="'+response.word1+'">');
            });

            return false;
        });

        self.outro = function(){


            wrapper.find('video').remove();
            inner.append(self.getVideoTag('video_'+lng+'/outro_1080.mp4', 'img/poster-outro.jpg'));

            var video = inner.find('video');

            wrapper.removeClass('show-input-box');

            video.on('ended', function(){
                window.location.reload();
            });

            video.on('canplay', function(){
                console.log('canPlay');

                setTimeout(function(){
                    var playPromise = video[0].play();

                    // In browsers that don’t yet support this functionality,
                    // playPromise won’t be defined.
                    if (playPromise !== undefined) {
                        playPromise.then(function() {
                            // Automatic playback started!
                            video.parent().parent().removeClass('paused');
                        }).catch(function(error) {
                            //trackJs.track(error);
                            console.log('promise error');
                            console.log(error);
                            clearTimeout(self.videoTimeout);
                            // Automatic playback failed.
                            // Show a UI element to let the user manually start playback.

                            video.off('timeupdate');
                            video.addClass('finished');
                        });
                    } else {
                        //video.parent().parent().removeClass('paused');
                    }

                },250);
            });

            video[0].load();

            var flag = false;
            video.on('click touchend', function(){
                if (!flag) {
                    flag = true;
                    setTimeout(function () {
                        flag = false;
                    }, 100);

                    var _video = video[0];

                    if (_video.paused) {
                        _video.play();
                        $(_video).parent().parent().removeClass('paused');
                    } else if (this.ended) {
                        _video.play();
                        $(_video).parent().parent().removeClass('paused');
                    } else {
                        _video.pause();
                        $(_video).parent().parent().addClass('paused');
                    }
                }
            });

            video.on('timeupdate', function(e){
                triggerWords(video);
            });

            setInterval(function () {
                triggerWords(video);
            }, 30);

            function repeatOften() {
                triggerWords(video);

                requestAnimationFrame(repeatOften);
            }
            requestAnimationFrame(repeatOften);

            function triggerWords(video) {
                if (video[0].currentTime > 12.75 && video[0].currentTime < 16.291) {
                    word1.className = '';
                }
                if (video[0].currentTime > 16.291) {
                    word1.className = 'hidden';
                }

                if (video[0].currentTime > 93.125 && video[0].currentTime < 95.25) {
                    word2.className = '';
                }
                if (video[0].currentTime > 95.25) {
                    word2.className = 'hidden';
                }
            }

            return false;
        };

    }
}
$(document).ready(function(){
    $('body').on('click', '.video-wrapper.initial', function(){
        console.log('initial click');
        var instance = new Video();
        instance.start();
    });
});

function preloadImage(url)
{
    var img=new Image();
    img.src=url;
}